import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import { APP_DUAL_LIST } from 'src/constants/queryKeys';
import { PATH_DASHBOARD } from 'src/routes/paths';
import useFormsModalStore from 'src/store/forms';

const DuelTableBreadcrumb = ({ applicationDetails }) => {
  const { setModal } = useFormsModalStore();

  return (
    <HeaderBreadcrumbs
      heading={`فهرست تورنومنت های محصول ${applicationDetails?.ApplicationTitle}`}
      links={[
        { name: 'داشبورد', href: PATH_DASHBOARD.general.home },
        { name: `فهرست تورنومنت های محصول ${applicationDetails?.ApplicationTitle}`, href: null },
      ]}
      action={
        <Button
          variant="contained"
          component={RouterLink}
          startIcon={<Iconify icon={'eva:plus-fill'} />}
          onClick={() => setModal({ isOpen: true, data: null, type: APP_DUAL_LIST, title: 'ایجاد تورنومنت' })}
        >
          تورنومنت جدید
        </Button>
      }
    />
  );
};

export default DuelTableBreadcrumb;
